import { render, staticRenderFns } from "./CompanyPllicies&Regulations.vue?vue&type=template&id=79828509&scoped=true&"
import script from "./CompanyPllicies&Regulations.vue?vue&type=script&lang=js&"
export * from "./CompanyPllicies&Regulations.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPllicies&Regulations.vue?vue&type=style&index=0&id=79828509&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79828509",
  null
  
)

export default component.exports